import React from 'react';
import profilePhoto from '../assets/images/profile.jpg'; 

const About = () => {
  return (
    <div className="bg-black text-white p-8">
      <h1 className="text-5xl md:text-6xl font-bold mb-8 text-center">About Me</h1>
      <div className="flex flex-col md:flex-row items-center md:items-start mb-8">
        <div className="w-full md:w-1/3 mb-8 md:mb-0">
          <img src={profilePhoto} alt="Amit Kedia" className="w-full h-auto rounded-lg" />
        </div>
        <div className="w-full md:w-2/3 md:pl-8">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Amit Kedia</h2>
          <p className="text-lg md:text-xl mb-4">
          I'm passionate about end-to-end analytical projects, transforming complex data into actionable insights. 
          I thrive on building proof-of-concepts and prototypes using cutting-edge LLM technologies, AI agents, 
          and frameworks like LangChain. Leveraging tools such as open-source and closed source model APIs, 
          Hugging Face, and Vector Databases, I create intelligent, agentic AI solutions 
          that drive innovation and efficiency. Whether it's developing sophisticated 
          analytics platforms or pioneering new AI-driven applications, 
          I am dedicated to pushing the boundaries of what's possible.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
